import { RecorderHealthMoreDetailInterface } from "api/interfaces/reportInterface.interface";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { IoChevronDownOutline, IoChevronUp } from "react-icons/io5";
import { statusToColor, upperStatus } from "./HealthMenus";
import { HealthMenuItem } from "../HealthStyled";

type Props = {
  currentMenu: RecorderHealthMoreDetailInterface;
  menus: RecorderHealthMoreDetailInterface[];
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  onChangeMenu: (index: number) => void;
};

export default function ResponsiveMobileMenu({
  currentMenu,
  menus,
  isOpen,
  setIsOpen,
  onChangeMenu,
}: Props): JSX.Element {
  return (
    <MobileWrapper>
      <MobileItem
        onClick={() => setIsOpen(!isOpen)}
        data-testid="reports-view-component-mobile-item-set-is-open"
      >
        <MobileInnerItem>
          <div className="health-menu-icon-wrapper">{currentMenu.icon}</div>
          <div className="health-menu-label-wrapper">
            <span className="label">{currentMenu.label}</span>
            <Value status={upperStatus(currentMenu.status)}>
              {currentMenu.subLabel
                ? `${currentMenu.value} ${currentMenu.subLabel}`
                : currentMenu.value}
            </Value>
          </div>
        </MobileInnerItem>
        <button>
          {isOpen ? (
            <IoChevronUp size={24} />
          ) : (
            <IoChevronDownOutline size={24} />
          )}
        </button>
      </MobileItem>
      {isOpen && (
        <MobileOpenBox>
          {menus.map((item, index) => (
            <MobileOpenItem
              key={index}
              index={index}
              onClick={() => {
                setIsOpen(false);
                onChangeMenu(index);
              }}
              data-testid="reports-view-component-mobile-open-item-set-is-open"
            >
              <div className="report-menu-icon">{item.icon}</div>
              <div className="report-menu-label">{item.label}</div>
            </MobileOpenItem>
          ))}
        </MobileOpenBox>
      )}
    </MobileWrapper>
  );
}

export const Value = styled.span<{ status?: string }>`
  color: #828b9b;
  color: ${({ status }) => statusToColor(status)};
  color: ${({ status }) => status === "HEALTHY" && COLORS.BUTTONS2};

  ${mediaQuery.isMobile} {
    font-size: ${calcRem(14)};
  }
`;

const MobileWrapper = styled.div`
  width: 100%;
  position: relative;
`;

const MobileItem = styled(HealthMenuItem)`
  ${FLEX.FlexBetweenCenter};
  padding: 14px 20px;

  button {
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

const MobileInnerItem = styled.div`
  ${FLEX.FlexStartCenter};
  color: ${COLORS.WHITE};
  font-size: ${calcRem(20)};
  gap: 16px;
  flex: 1;

  .health-menu-icon-wrapper {
    width: 35px;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  img {
    width: 100%;
  }
  .health-menu-label-wrapper {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 4px;

    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

const MobileOpenBox = styled.ul`
  border: 1px solid ${COLORS.BUTTONS1};
  border-radius: 5px;
  padding: 0 10px;
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : "#070e17"};
  width: 100%;
  position: absolute;
  z-index: 990;
`;

const MobileOpenItem = styled.li<{ index: number }>`
  cursor: pointer;
  padding: 12px 0;
  ${FLEX.FlexStartCenter};
  flex: 1;
  gap: 10px;
  ${({ index }) =>
    index !== 0 &&
    `
      border-top: 1px solid ${COLORS.BORDER};
  `}
  width: 100%;

  color: ${({ theme }) => theme.COLORS.WHITE};

  .report-menu-icon {
    /* flex: 1; */
    width: 30px;
    height: 30px;
    > svg {
      width: 100%;
      height: 100%;
    }
  }
  .report-menu-label {
    flex: 1;
  }
`;
